import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';
import { createECDH } from 'crypto';
import { ApexOptions } from 'ng-apexcharts';
import { title } from 'process';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'], 
  encapsulation: ViewEncapsulation.None
})
export class AnalyticsComponent implements OnInit , OnDestroy , AfterViewInit {
  analyticsData: any
  roleChartOptions: any;
  countryChartOptions: any
  usersRoles: any
  usersByCountries: any
  verificationOption: any
  subRolesOption: any
  friendsChart: any
  postChart: any
  registrationPerDay: any
  registerPerMonth: any
  popularProfile: any
  rows: any
  columns: any
  profileSegement: any
  registrationLastWeek: any
  weeklypost: any
  repeatedLoggedInLastMonth: any
  repeatedLoggedInLastWeek: any
  commonClubs: any
  clubsAddedByAUser: any
  repeatedLoginsByRole: any
  gamesByCountryOption: any
  gamesByBucketsOption: any
  challengesByBucketsOption: any
  private subscription: Subscription[] = []
  wallet: any;

  constructor(
    private apiService: ApisService , 
    private loading : LoadingService
  ) {

  }





/*=============================================
=            Life Cycle hooks            =
=============================================*/

ngOnInit(): void {
  this.loading.show()
  this.getAllCards()
  this.usersRole()
  this.fetchAnalytics()
  this.fetchAnalyticsOfCountry()
  this.fetchVerificationanalytics()
  this.subRolesAnaytics()
  this.friendsCountAnalytics()
  this.postCountsAnalytics()
  this.registrationAnalytics()
  this.registrationPerMonth()
  this.mostViewedProfile()
  this.profileSegementation()
  this.registrationLastweek()
  this.weeklyposts()
  this.repeatedLoginLastMonth()
  this.repeatedLoginLastWeek()
  this.popuarClubs()
  this.clubsAddedByOneUser()
  this.repeatedLoginByRole()
  this.gamesByCountry()
  this.gamesByBuckets()
  this.challengesByBuckets()
  this.walletInsights()
  
}
ngAfterViewInit(): void {
  setTimeout(() => {
    this.loading.hide()
  }, 3000);
}

/*=====  End of Life Cycle hooks  ======*/

  /*---------- wallets insights  ----------*/
  walletInsights(){
    this.apiService.walletInsights().subscribe({
      next:(res)=>{
         this.wallet = Object.keys(res).map(currency => ({
          currency,
          totalIncome: res[currency].totalIncome,
          totalDept: res[currency].totalDept
        }));


        console.log(this.wallet)
      }, 
      error(err) {
        console.log("Error in fetching data" , err);
      }
    })
  }

  // Get all info about the cards
  getAllCards() {
    this.apiService.getAllCards().subscribe({
      next: (res) => {
        console.log("response of all cards:", res)

      },
      error(err) {
        console.log("Error in fetching ", err)
      },
    })
  }

  // Fetching registration in past 24h 
  registrationAnalytics() {
    this.subscription.push(this.apiService.registrationPastDay().subscribe({
      next: (res: any) => {
        this.registrationPastDay(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    }))
  }

  // Registration per month
  registrationPerMonth() {
    this.subscription.push(this.apiService.registrationPerMonth().subscribe({
      next: (res: any) => {
        this.registrationPerMonthChart(res)
        console.log("Registration per month",res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    }))
  }

  // Most viewed Profile analytics 
  mostViewedProfile() {
this.subscription.push(    this.apiService.mostViewedProfile().subscribe({
  next: (res: any) => {
    this.mostViewedProfileChart(res)
  },
  error(err) {
    console.log("Error in fetching", err)
  },
}))
  }

  // Profile segementation 
  profileSegementation() {
this.subscription.push(    this.apiService.profileSegementation().subscribe({
  next: (res: any) => {
    this.profileSegementationChart(res)
  },
  error(err) {
    console.log("Fetching error", err)
  }
}))

  }

  // Regestration by role last 7 days 
  registrationLastweek() {
this.subscription.push(    this.apiService.registrationByRole().subscribe({
  next: (res) => {
    this.registrationByRoleChart(res)
  },
  error(err) {
    console.log(err)
  },
}))
  }

  weeklyposts() {
   const sub = this.apiService.weeklyposts().subscribe({
      next: (res) => {
        this.weeklyPostsChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
    this.subscription.push(sub)
  }

  repeatedLoginLastMonth() {
   const sub = this.apiService.repeatedLoginsLastMonth().subscribe({
      next: (res) => {
        this.repeatedLoginsLastMonthChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
    this.subscription.push(sub)
  }

  repeatedLoginLastWeek() {
   const sub = this.apiService.repeatedLoginsLastWeek().subscribe({
      next: (res) => {
        this.repeatedLoginsLastWeekChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
this.subscription.push(sub)
  }

  popuarClubs() {
   const sub = this.apiService.clubsAddedByUsers().subscribe({
      next: (res) => {
        this.commonClubsChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
    this.subscription.push(sub)
  }
  clubsAddedByOneUser() {
  const sub =  this.apiService.clubsAddedByOneUser().subscribe({
      next: (res: any) => {
        this.clubsAddedByOneUserChart(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }

  repeatedLoginByRole() {
   const sub =  this.apiService.repeatedLoginsByRole().subscribe({
      next: (res) => {
        this.repeatedLoginsByRoleChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
    this.subscription.push(sub)
  }

  gamesByCountry() {
   const sub =  this.apiService.gamesByCountry().subscribe({
      next: (res) => {
        this.gamesByCountryChart(res)
      },
      error(err) {
        console.log(err)
      },
    })
    this.subscription.push(sub)
  }

  gamesByBuckets() {
    this.apiService.gamesByBuckets().subscribe({
      next: (res) => {
        this.gamesByBucketsChart(res)
      },
      error(err) {
        console.log(err)
      }

    })

  }
  challengesByBuckets() {
 const sub =   this.apiService.challengesByBuckets().subscribe({
      next: (res) => {
        this.challengesByBucketsChart(res)
      },
      error(err) {
        console.log(err)
      }
    })
    this.subscription.push(sub)
  }

  // Fetching data for analytics 
  usersRole() {
  const sub =  this.apiService.adminDashboard().subscribe({
      next: (res: any) => {
        this.usersRoles = res.data?.data?.personas
        console.log("User Roles : ", this.usersRoles)

      },
      error(err) {
        console.log("Fetching error", err)
      },
    })
    this.subscription.push(sub)
  }

  // Fetching analytics 
  fetchAnalytics() {
  const sub =  this.apiService.fetchAnalytics().subscribe({
      next: (res: any) => {
        this.analyticsData = res
        this.setupRolesChart(this.analyticsData);
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }

  // Fetching analytics of the country 
  fetchAnalyticsOfCountry() {
  const sub =  this.apiService.fetchAnalyticsByCountry().subscribe({
      next: (res: any) => {
        this.usersByCountries = res
        this.setUpCountryChart(this.usersByCountries)
      }
      , error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }

  // verification analytics 
  fetchVerificationanalytics() {
  const sub =  this.apiService.verificationStatus().subscribe({
      next: (res: any) => {
        this.verificationChart(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }

  // Sub Roles analytics
  subRolesAnaytics() {
 const sub =   this.apiService.subRoles().subscribe({
      next: (res: any) => {
        this.subRolesChart(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }
  friendsCountAnalytics() {
  const sub =   this.apiService.friendsCount().subscribe({
      next: (res: any) => {
        this.friendsCountChart(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }

  postCountsAnalytics() {
   const sub = this.apiService.postsCount().subscribe({
      next: (res: any) => {
        this.postCountsChart(res)
      },
      error(err) {
        console.log("Error in fetching", err)
      },
    })
    this.subscription.push(sub)
  }
  // Roles Chart
  setupRolesChart(apiResponse: any) {

    const rolesChart = apiResponse.data?.rows.map(rows => ({
      values: rows[0],
      labels: rows[1]
    }))

    rolesChart.sort((a, b) => b.values - a.values);

    let values = rolesChart.map(rows => rows.values)
    let labels = rolesChart.map(rows => rows.labels)


    this.roleChartOptions = {
      // You need to find where the actual numerical data is stored
      series: values, // This needs to be an array of numbers
      chart: {
        type: "pie",
        height: 220,
      },
      labels: labels, // Categories (Roles)

    };
  }
  // Useres by Country Chart
  setUpCountryChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    //  determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      value: rows[0],
      label: rows[1]
    }));

    // Sortting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the first 6 sorted values and labels
    const topValues = chartData.map(data => data.value).slice(0, 6);
    const topLabels = chartData.map(data => data.label).slice(0, 6);

    const otherValues = chartData.map(data => data.value).slice(6).reduce((sum, data) => sum + data, 0); //getting the remaining values and summing them together 

    const values = [...topValues, otherValues];
    const labels = [...topLabels, 'Others'];

    // Set the chart options
    this.countryChartOptions = {
      series: values, // Array of sorted numerical values
      chart: {
        type: "pie",
        height: 220,
      },
      labels: labels, // Array of corresponding labels
    };
  }
  // Verification Status Chart
  verificationChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    //  determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      value: rows[0],
      label: rows[1]
    }));

    // Sortting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.value)
    const labels = chartData.map(data => data.label)

    // Set the chart options
    this.verificationOption = {
      series: values, // Array of sorted numerical values
      chart: {
        type: "donut",
        height: 220,
      },
      labels: labels, // Array of corresponding labels
    };
  }

  // Sub Roles Chart 
  subRolesChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      value: rows[0],
      label: rows[1].split("_").join("  ")
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.value).slice(0, 6)
    const labels = chartData.map(data => data.label).slice(0, 6)


    // Set the chart options
    this.subRolesOption = {
      series: [{
        name: 'Sub Roles',
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },
      labels: labels // Array of corresponding labels
    };
  }
  // friends count chart 
  friendsCountChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1]
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)

    // Set the chart options
    this.friendsChart = {
      series: values,
      chart: {
        type: "pie",
        height: 220,
      },

      labels: labels,

    };

  }

  postCountsChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      values: rows[0],
      labels: rows[1]
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)

    // Set the chart options
    this.postChart = {
      series: [{
        name: "Post Counts",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220
      },
      plotOptions: {
        bar: {
          horizontal: true // This makes the bar chart horizontal
        }
      },
      labels: labels,
      xaxis: {
        reversed: true // This reverses the horizontal bar chart
      }
    };


  }
  registrationPastDay(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0]
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)

    // Set the chart options
    this.registrationPerDay = {
      series: values,
      chart: {
        type: "pie",
        height: 220,
      },

      labels: labels,

    };
  }
  registrationPerMonthChart(apiResponse: any) {
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1]
    })).slice(10);
    console.log("Registration data" , chartData)

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)

    // Set the chart options
this.registerPerMonth = {
  series: [{
    name: "Total new Registration per month",
    data: values
  }],
  chart: {
    type: "line",
    height: 220,
  },
  labels: labels,
  yaxis: {
    // Option 1: Logarithmic Scale (to handle large values)
    logarithmic: true,
    
    // Option 2: Set max value manually (optional)
    // max: 1000, // Adjust this number based on your data

    title: {
      text: "Profile Views",
    },
    labels: {
      formatter: function (val) {
        return Math.round(val);
      }
    }
  },
  xaxis: {
    labels: {
      rotate: -45, // Optional: tilt labels to prevent overlapping
    }
  }
};



  }

  mostViewedProfileChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      firstName: rows[0],
      lastName: rows[1],
      views: rows[2]
    }));

    chartData.sort((a, b) => b.views - a.views);

    this.rows = chartData;

    // Define the columns
    this.columns = [
      { name: 'First Name', prop: 'firstName' },
      { name: 'Last Name', prop: 'lastName' },
      { name: 'Views', prop: 'views' }
    ];
  }

profileSegementationChart(apiResponse: any) {
  const countriesChart = apiResponse.data?.rows;
  console.log('countriesChart:', countriesChart);

  if (!countriesChart) {
    console.error("No chart data available.");
    return;
  }

  // Aggregate data by labels
  const aggregatedData = {};

  countriesChart.forEach(row => {
    const label = row[0];  
    const value = row[1];  
    if (aggregatedData[label]) {
      aggregatedData[label] += value;
    } else {
      aggregatedData[label] = value;
    }
  });

  console.log('aggregatedData:', aggregatedData);


const labels = Object.keys(aggregatedData)
const values = Object.values(aggregatedData);

  // Set the chart options
this.profileSegement = {
  series: [{
    name: "Profile Segmentation",
    data: values
  }],
  chart: {
    type: "bar",
    height: 220,
  },
  xaxis: {
    categories: labels,
    type: 'category',  
    title: {
      text: "Profile Segmentation",
    },
    labels: { 
      rotate: -45,
    },
  },
  yaxis: {
    title: {
      text: "User Count",
    },
    labels: {
      formatter: function (val) {
        return Math.round(val);
      }
    }
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val.toLocaleString();
      }
    }
  },

   labels: labels,
};

}




  registrationByRoleChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1]
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels.slice(0, 10))

    console.log(labels)

    // Set the chart options
    this.registrationLastWeek = {
      series: [{
        name: "Total number of users by age and gender",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,

    };

  }

  weeklyPostsChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1],
      category: rows[2]
    }));

    // Sorting data in descending order
    chartData.sort((a, b) => b.value - a.value);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels.slice(0, 10))
    const category = chartData.map(data => data.category)

    console.log(labels)

    // Set the chart options
    this.weeklypost = {
      series: [{
        name: "Profile Segementation",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
    };

  }

  repeatedLoginsLastMonthChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0],
    })).slice(0, 7);


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.repeatedLoggedInLastMonth = {
      series: values,
      chart: {
        type: "pie",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };

  }
  repeatedLoginsLastWeekChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0],
    })).slice(0, 7);


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.repeatedLoggedInLastWeek = {
      series: values,
      chart: {
        type: "pie",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };

  }
  commonClubsChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.commonClubs = {
      series: [{
        name: "Common Clubs",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };

  }
  clubsAddedByOneUserChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.clubsAddedByAUser = {
      series: [{
        name: "Common Clubs",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };


  }

  repeatedLoginsByRoleChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[1],
      values: rows[0],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels.slice(0, 10))


    console.log(values)

    // Set the chart options
    this.repeatedLoginsByRole = {
      series: [{
        name: "Common Clubs",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };


  }

  gamesByCountryChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    const viewedValues = chartData.map(data => data.values).slice(0, 10)
    const hiddenValues = chartData.map(data => data.values).slice(11).reduce((sum, data) => sum + data, 0);
    const viewedLabels = chartData.map(data => data.labels).slice(0, 10)

    // Extract the sorted values and labels
    const values = [...viewedValues, hiddenValues]
    const labels = [...viewedLabels, "Others"]


    console.log(values)

    // Set the chart options
    this.gamesByCountryOption = {
      series: [{
        name: "games by country",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };


  }
  gamesByBucketsChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.gamesByBucketsOption = {
      series: [{
        name: "post by buckets",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };


  }

  challengesByBucketsChart(apiResponse: any) {
    console.log(apiResponse)
    const countriesChart = apiResponse.data?.rows;

    // Ensure the data is available
    if (!countriesChart) {
      console.error("No chart data available.");
      return;
    }

    // Determine the values and the labels 
    const chartData = countriesChart.map(rows => ({
      labels: rows[0],
      values: rows[1],
    }));


    // Sorting data in descending order
    chartData.sort((a, b) => b.values - a.values);

    // Extract the sorted values and labels
    const values = chartData.map(data => data.values)
    const labels = chartData.map(data => data.labels)


    console.log(values)

    // Set the chart options
    this.challengesByBucketsOption = {
      series: [{
        name: "post by buckets",
        data: values
      }],
      chart: {
        type: "bar",
        height: 220,
      },

      labels: labels,
      margin: 5,
    };


  }
  // Destroying all the subscriptions
  ngOnDestroy(): void {
   this.subscription.forEach((sub) => {
    console.log("unsubscribed");
    sub.unsubscribe();
   });
  }
  
}